<template>
  <div>
    <div class="audit3 page landscape">
      <Logo />

      <div class="flex">
        <div class="info">
          <div class="container">
            <center><h1>Audyt i wdrożenie Google Analytics</h1></center>
            <h4>
              Aby poprawić ruch na twojej stronie niezbędny jest Audyt SEO
            </h4>
            <ul>
              <li>
                Twoja strona potrzebuje szczegółowej analizy SEO technicznej
              </li>
              <li>
                Przygotujemy rekomendacje na podstawie ponad 50 wytycznych,
                które poprawią działanie
              </li>
              <li>
                strony. Dzięki temu ruch wzrośnie i poprawi się widoczność
                strony na frazy z największym potencjałem wyszukiwania
              </li>
              <li>
                Damy Ci nielimitowane wsparcie we wdrożeniu wytycznych i
                będziemy pilnować projektu, aby dowieźć wszystkie niezbędne do
                osiągnięcia sukcesu zmiany
              </li>
            </ul>
            <h4>
              Otrzymasz pełny zestaw precyzyjnych wytycznych, dzięki którym:
            </h4>
            <ul>
              <li>
                Wzrośnie ruch w na Twojej stronie, a co za tym idzie liczba
                klientów
              </li>
              <li>
                Twój serwis będzie bardziej przyjazny dla użytkowników i robotów
                wyszukiwarek
              </li>
              <li>
                Poprawisz szybkość działania strony i jej ocenę w rankingach
                Google
              </li>
              <li>
                Audyt to inwestycja, która pracuje na wzrosty ruchu każdego dnia
                po wdrożeniu
              </li>
            </ul>
          </div>
        </div>
        <div class="bg-image">
          <img src="/col3.jpg" alt="" srcset="" />
          <div class="overlay"></div>
        </div>
      </div>
      <center>
        <img
          src="https://vecta.io/blog/best-practices-for-svg-seo-in-google-image/best-practices-for-svg-seo-in-google-image.e39f2b7fd1.svg"
          alt=""
          srcset=""
          style="
            width: 30%;
            margin: 0;
            padding: 0;
            margin-left: -400px;
            margin-top: -50px;
          "
        />
      </center>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  name: 'Audit3',
  components: {
    Logo,
  },
  props: {
    msg: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.audit3 {
  color: #000 !important;
  text-align: left;
}

.audit3 img {
  margin-top: 25px;
}
h1 {
  font-size: 42px;
  color: #000;
}

h3 {
  font-size: 42px;
}
.flex {
  display: flex;
  align-items: space-around;
  justify-content: center;
  /* margin-top: 50px; */
  /* padding: 0 50px; */
}

.single-flex {
  /* padding: 0 25px; */
}

li {
  text-justify: inter-word;
  text-align: justify;
}

h3 {
  text-align: center;
}
.audit3 {
  /* background:url(https://i.picsum.photos/id/1018/3914/2935.jpg); */
  background-size: cover;
  color: #fff;
  z-index: 0;
}

.background {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  background: #000;
  opacity: 0.3;
  z-index: -1;
}
</style>
